
export const BACKEND_API_URL = "https://backend.drops.thenftbrewery.com"
